export default {
  install(Vue, options) {
    // Добавляем глобальный метод $ym
    Vue.prototype.$ym = function(goal, params = {}) {
      // Без optional chaining для Vue 2
      const counterId = (options && options.counterId) || 106349139;
      
      if (window.ym) {
        console.log(`Отправка цели "${goal}" в Яндекс.Метрику с параметрами:`, params);
        window.ym(counterId, 'reachGoal', goal, params);
      } else {
        console.warn('Yandex Metrika не загружена. Цель "' + goal + '" не отправлена');
      }
    };
  }
};